import { useCareerPaths } from 'apps/main/libs/navigation/data-access-path'
import PathList from 'apps/main/libs/path/ui-path-list'
import classNames from 'classnames/bind'
import { useTranslation } from 'next-i18next'
import styles from './CareerNavigation.module.scss'

const cx = classNames.bind(styles)

type CareerNavigationProps = {
  currentPathSlug?: string
}

const CareerNavigation = ({ currentPathSlug }: CareerNavigationProps) => {
  const { t } = useTranslation()
  const { careerPaths } = useCareerPaths()

  const paths = careerPaths.map(({ title, slug }) => {
    const link = `/paths/career/${slug}`
    return {
      title,
      link,
      isSelected: slug === currentPathSlug,
    }
  })

  return (
    <div className={cx('container')}>
      <p className={cx('title')}>{t('CareerPath_CAREER')}</p>
      <div className={cx('pathList')}>
        <PathList paths={paths} />
      </div>
    </div>
  )
}

export default CareerNavigation
